import { render, staticRenderFns } from "./DiNapoli.vue?vue&type=template&id=838c323a&scoped=true"
import script from "./DiNapoli.vue?vue&type=script&lang=js"
export * from "./DiNapoli.vue?vue&type=script&lang=js"
import style0 from "./DiNapoli.vue?vue&type=style&index=0&id=838c323a&prod&lang=css"
import style1 from "./DiNapoli.vue?vue&type=style&index=1&id=838c323a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c323a",
  null
  
)

export default component.exports